/* eslint-disable */
export default string =>
  new Uint8Array(string.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
